import { render } from "./goaltos.vue?vue&type=template&id=21bae638"
import script from "./goaltos.vue?vue&type=script&lang=js"
export * from "./goaltos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__